import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { PromotionAction } from '../models/promotionAction.model';
import { SebbieTask } from '../models/sebbietask.model';

@Injectable({
  providedIn: 'root'
})
export class SebbieService {
  private baseApiUrl: string;
  private baseAuthenticatedApiUrl: string;

  public continuationTokenHistory: string = null;

  constructor(
    private httpService: HttpClient,
    private readonly configService: AppConfigService
  ){
    this.baseApiUrl = this.configService.getConfig().baseApiUrl;
    this.baseAuthenticatedApiUrl = `${this.baseApiUrl}Auth/`;
  }

  getCurrentPromotionAction(token: string): Promise<PromotionAction> {
    return new Promise((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': token
        })
      };

      this.httpService.get<PromotionAction>(`${this.baseAuthenticatedApiUrl}Sebbie/PromotionAction`, httpOptions)
        .subscribe({
          next: (result: PromotionAction) => {
            resolve(result);
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  getCurrentPromotionActionTasks(token: string): Promise<Array<SebbieTask>> {
    return new Promise((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': token
        })
      };

      this.httpService.get<Array<SebbieTask>>(`${this.baseAuthenticatedApiUrl}Sebbie/PromotionAction/Tasks`, httpOptions)
        .subscribe({
          next: (result: Array<SebbieTask>) => {
            resolve(result);
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }

  getPastPromotionActionsForUser(token: string): Promise<Array<PromotionAction>> {
    return new Promise((resolve, reject) => {
      var headers: HttpHeaders = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': token
      })

      if(this.continuationTokenHistory){
        headers = headers.append('x-ms-continuationtoken', this.continuationTokenHistory);
      }

      const httpOptions = {
        headers: headers,
        observe: 'response' as const,
      };
      
      this.httpService.get<Array<PromotionAction>>(`${this.baseAuthenticatedApiUrl}Sebbie/PastPromotionActions`, httpOptions)
        .subscribe({
          next: (response: any) => {
            this.continuationTokenHistory = response.headers.get('x-ms-continuationtoken');
            resolve(response.body);
          },
          error: (error) => {
            reject(error);
          }
        });
    });
  }
}